import { accountStore } from "entities/account";
import { onboardModel } from "entities/onboard";
import { sessionModel } from "entities/session";
import { PropsWithChildren, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sircapApi } from "shared/api/sircap";
import { PATH_LIST } from "shared/lib/react-router";
import Loading from "widgets/loading";
import { useStore } from "zustand";

export function AppGuard(props: PropsWithChildren) {
  const { addUser, accessToken, refreshToken } = useStore(
    sessionModel.sessionStore
  );
  const { synckyc, synckyb } = useStore(accountStore);
  const { syncUser } = useStore(onboardModel.onboardStore);
  const navigate = useNavigate();
  const location = useLocation();
  const { t: err } = useTranslation("errors");
  const { t: notif } = useTranslation("toast");

  const [isLogined, setIsLogined] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const auth = async () => {
    setIsLoading(true);
    try {
      // console.log("refreshToken in app guard", refreshToken);
      sircapApi.setSecurityData(refreshToken);
      const resp = await sircapApi.auth.token({
        timeout: 15000, // 15 seconds
      });
      if (resp.error) setIsLogined(false);
      else {
        const {
          user,
          accessToken,
          refreshToken,
          entity,
          kyc,
          kyb,
          questionnaireStatus,
          biometrics,
          biometric,
          fcmToken,
          crsData,
          subAccounts,
        } = resp.data.data;
        // add check if user.status is active
        syncUser(user, entity);
        synckyc(kyc || null);
        synckyb(kyb || null);
        accountStore.setState({ questionnaireStatus });
        addUser(
          user,
          accessToken,
          refreshToken,
          entity,
          biometrics,
          biometric,
          fcmToken,
          crsData,
          subAccounts
        );

        if (user.status !== 1) {
          navigate(PATH_LIST.createAccount);
        } else {
          // toast.success("Success login");
          // navigate(PATH_LIST.home);
          setIsLogined(true);
        }
      }
    } catch (error) {
      console.log("error in app guard", error);
      setIsLogined(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // console.log("accessToken in app guard", accessToken);
    // if (!accessToken) return;
    // auth();
    if (isLogined === null && !isLoading) {
      if (accessToken) {
        auth();
      } else {
        sessionStorage.setItem("redirect", location.pathname);
        navigate(PATH_LIST.welcome);
      }
    }
  }, [accessToken, isLogined, isLoading]);

  if (isLogined === null || isLoading) return <Loading />;

  if (!isLogined) {
    // toast.info(notif("sessionExpired"), {
    //   className: "session-expired",
    //   bodyClassName: "session-expired-text",
    //   hideProgressBar: true,
    // });
    sessionStorage.setItem("redirect", location.pathname);
    toast.info(notif("sessionExpired"));
    return <Navigate to={PATH_LIST.login} />;
  }

  return <>{props.children}</>;
}
